import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* ContractPdfCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.CONTRACT_PDF_CREATE_REQUEST
    });

    const res = yield call(Http.post, `contract/contract-details`, {
      ...action.payload
    });

    yield put({
      type: Constants.CONTRACT_PDF_CREATE_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res?.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.CONTRACT_PDF_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchContractPdfCreate() {
  yield takeEvery(Constants.CONTRACT_PDF_CREATE_START, ContractPdfCreate);
}
